import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalInputText, ModalInputTextLimit, ModalInputSwitch3, ModalText } from "../../manage/components/Modal";
import { CardsModalDropdown } from "./OrderCard";
import { gatewayRequest, ssoRequest, businessCardsRequest } from '../../../../../Networking';
import './Modals.scss';
import IconInputYellow16px from '../../../assets/Icon_Input_Yellow-16px.svg';
import IconParamsYellow16px from '../../../assets/Icon_Params_Yellow-16px.svg';

export const EditParams = connect(state => ({ translation: state.translation.cards.editParamsModal }))(class extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            refuelingParameters: Object.entries(this.props.refuelingParameters).map(x => ({ text: x[1], onClick: () => this.setState({ selectedRefuelingParameter: x[0] }) })),
            selectedRefuelingParameter: this.props.refuelingParameter || 0,
            isLoaderVisible: false, isDone: false, isError: false, result: null
        };
    }

    editRefuelingParam = (cardNumber, refuelingParameter) => {
        this.setState({ isLoaderVisible: true }, () => {
            this.props.updateCards(
                {
                    "requestType": "updateRefuelingParameter",
                    "cardNumber": cardNumber,
                    "refuelingParameter": refuelingParameter
                },
                data => this.setState({
                    result: data.records.result,
                    isDone: data.records.statusCode === 200,
                    isError: data.records.statusCode !== 200,
                    isLoaderVisible: false
                }),
                error => this.setState({ isLoaderVisible: false }))
        });
    }

    onFieldChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    }

    render() {
        return (
            <Modal {...{
                title: this.props.translation.titleAdd,
                onCloseButtonClick: this.props.onModalClose,
                content:
                    <>
                        <CardsModalDropdown {...{
                            type: "refueling",
                            title: this.props.translation.paramField,
                            text: this.state.refuelingParameters[this.state.selectedRefuelingParameter].text,
                            items: this.state.refuelingParameters
                        }} />
                    </>,
                isSaveButton: true,
                actionButtonTitle: this.props.translation.editButton,
                actionButtonImg: IconParamsYellow16px,
                onActionButtonClick: () => this.editRefuelingParam(this.props.number, this.state.selectedRefuelingParameter),
                isLoaderVisible: this.state.isLoaderVisible,
                isDone: this.state.isDone,
                isError: this.state.isError,
                result: this.state.result,
                height: 112
            }} />
        )
    }
});

export const EditCardName = connect(state => ({ translation: state.translation.cards.editCardNameModal }), null)(class extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { name: props.name || "", isLoaderVisible: false, isDone: false, isError: false, result: null };
    }

    validate = (name) => {
        return name !== undefined && name !== null && name !== "";
    }

    editName = (cardNumber, cardNumbers, cardName) => {
        if (!this.validate(cardName)) {
            return;
        }
        this.setState({ isLoaderVisible: true }, () => {
            this.props.updateCards(
                {
                    "requestType": "editCardName",
                    "cardNumber": cardNumber,
                    "cardNumbers": cardNumbers,
                    "cardName": cardName
                },
                data => this.setState({
                    result: data.records.result,
                    isDone: data.records.statusCode === 200,
                    isError: data.records.statusCode !== 200,
                    isLoaderVisible: false
                }),
                error => this.setState({ isLoaderVisible: false }))
        });
    }

    onFieldChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    }

    render() {
        return (
            <Modal {...{
                title: this.props.translation.title,
                onCloseButtonClick: this.props.onModalClose,
                content:
                    <>
                        <ModalInputText {...{
                            text: this.props.translation.nameField,
                            id: "name",
                            value: this.state.name,
                            onChange: this.onFieldChange,
                            maxLength: 30,
                            required: true,
                            backgroundImage: "card"
                        }} />
                    </>,
                isSaveButton: true,
                actionButtonTitle: this.props.translation.saveButton,
                actionButtonImg: IconInputYellow16px,
                onActionButtonClick: () => this.editName(this.props.number, this.props.numbers, this.state.name),
                isLoaderVisible: this.state.isLoaderVisible,
                isDone: this.state.isDone,
                isError: this.state.isError,
                result: this.state.result,
                height: 112
            }} />
        )
    }
});

export const EditCardLimits = connect(state => ({ translation: state.translation.cards.editCardLimitsModal }), null)(class extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            limit: this.props.limit || 0,
            dayLimit: this.props.dayLimit || 0,
            fuel: (this.props.fuel && this.props.fuel + 1) || 2, //translate fuel [1, 2] to modalinputtext3 fuel [2, 3]
            product: this.props.product || 1,
            isLoaderVisible: false, isDone: false, isError: false, result: null
        };
    }

    validate = (limit) => {
        return limit !== undefined && limit !== null && limit !== "" && limit >= 0;
    }

    editLimit = (cardNumber, cardNumbers, cardLimit, dayLimit, allowedFuel, allowedProduct) => {
        if (!this.validate(cardLimit) || !this.validate(dayLimit)) {
            return;
        }
        this.setState({ isLoaderVisible: true }, () => {
            this.props.updateCards(
                {
                    "requestType": cardNumber ? "editCardLimit" : "editCardsLimit",
                    "cardNumber": cardNumber,
                    "cardNumbers": cardNumbers,
                    "limit": cardLimit,
                    "dayLimit": dayLimit,
                    "allowedFuel": allowedFuel,
                    "allowedProduct": allowedProduct
                },
                data => this.setState({
                    result: data.records.result,
                    isDone: data.records.statusCode === 200,
                    isError: data.records.statusCode !== 200,
                    isLoaderVisible: false
                }),
                error => this.setState({ isLoaderVisible: false }))
        });
    }

    onFieldChange = (e) => {
        try {
            if (e.target.value.length === 0 || /^(0|[1-9][0-9]{0,9})$/.test(e.target.value)) {
                const value = parseInt(e.target.value);
                this.setState({ [e.target.id]: isNaN(value) ? "" : value });
            }
        } catch (e) {
        }
    }

    onFuelTypeChange = (fuel) => {
        this.setState({ fuel: fuel, product: fuel === 2 ? 1 : this.state.product });
    }

    onProductTypeChange = (product) => {
        this.setState({ product: product });
    }

    render() {
        const inputSize = Math.max((this.state.limit && this.state.limit.length) || 0, 1);
        return (
            <Modal {...{
                title: this.props.translation.title,
                onCloseButtonClick: this.props.onModalClose,
                content:
                    <>
                        <ModalInputTextLimit {...{
                            text: this.props.translation.limitField,
                            id: "limit",
                            value: this.state.limit,
                            onChange: this.onFieldChange,
                            maxLength: 9,
                            required: true,
                            size: inputSize,
                            clientTotalLimit: this.props.clientTotalLimit
                        }} />
                        <ModalInputTextLimit {...{
                            text: this.props.translation.dayLimitField,
                            id: "dayLimit",
                            value: this.state.dayLimit,
                            onChange: this.onFieldChange,
                            maxLength: 9,
                            required: true,
                            size: inputSize,
                            perPeriod: 'day',
                            clientTotalLimit: this.props.clientTotalLimit
                        }} />
                        <ModalInputSwitch3 {...{
                            className: "modals-card-limits-fuel-types-switch",
                            text: this.props.translation.fuelField,
                            item1: null,
                            item2: this.props.translation.fuel1,
                            item3: this.props.translation.fuel2,
                            active: this.state.fuel,
                            disabled: true,
                            item2Click: () => this.onFuelTypeChange(2),
                            item3Click: () => this.onFuelTypeChange(3),
                        }} />
                        <ModalInputSwitch3 {...{
                            text: this.props.translation.productField,
                            item1: this.props.translation.product1,
                            item2: this.props.translation.product2,
                            item3: this.props.translation.product3,
                            active: this.state.product,
                            disabled: true,
                            item1Click: () => this.onProductTypeChange(1),
                            item2Click: () => this.onProductTypeChange(2),
                            item3Click: () => this.onProductTypeChange(3),
                        }} />
                    </>,
                isSaveButton: true,
                actionButtonTitle: this.props.translation.saveButton,
                onActionButtonClick: () => this.editLimit(this.props.number, this.props.numbers, this.state.limit, this.state.dayLimit, this.state.fuel - 1, this.state.product), //translate modalinputswitch3 fuel [2, 3] to fuel [1, 2]
                isLoaderVisible: this.state.isLoaderVisible,
                isDone: this.state.isDone,
                isError: this.state.isError,
                result: this.state.result,
            }} />
        )
    }
});

export const BlockCard = connect(state => ({ translation: state.translation.cards.blockCardModal }), null)(class extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { reason: "", isLoaderVisible: false, isDone: false, isError: false, result: null };
    }

    blockCard = (cardNumber, cardNumbers, blockReason) => {
        this.setState({ isLoaderVisible: true }, () => {
            this.props.updateCards(
                {
                    "requestType": cardNumber ? "blockCard" : "blockCards",
                    "cardNumber": cardNumber,
                    "cardNumbers": cardNumbers,
                    "blockReason": blockReason,
                },
                data => this.setState({
                    result: data.records.result,
                    isDone: data.records.statusCode === 200,
                    isError: data.records.statusCode !== 200,
                    isLoaderVisible: false
                }),
                error => this.setState({ isLoaderVisible: false }))
        });
    }

    onFieldChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    }

    render() {
        return (
            <Modal {...{
                title: this.props.translation.title,
                onCloseButtonClick: this.props.onModalClose,
                content:
                    <>
                        {this.props.name && <p className="modals-block-card-info-text">{this.props.translation.contentBlockCard(this.props.name)}</p>}
                        {this.props.numbers && <p className="modals-block-card-info-text">{this.props.translation.contentBlockCards(this.props.numbers.length)}</p>}
                        <ModalInputText {...{
                            text: this.props.translation.reasonField,
                            id: "reason",
                            value: this.state.name,
                            onChange: this.onFieldChange
                        }} />
                    </>,
                isSaveButton: true,
                actionButtonTitle: this.props.translation.blockButton,
                onActionButtonClick: () => this.blockCard(this.props.number, this.props.numbers, this.state.reason),
                isLoaderVisible: this.state.isLoaderVisible,
                isDone: this.state.isDone,
                isError: this.state.isError,
                result: this.state.result,
                height: 156
            }} />
        )
    }
});

export const ExtendCard = connect(state => ({ translation: state.translation.cards.extendCardModal }), null)(class extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { isLoaderVisible: false, isDone: false, isError: false, result: null };
    }

    extendCard = (cardNumber, cardNumbers) => {
        this.setState({ isLoaderVisible: true }, () => {
            this.props.updateCards(
                {
                    "requestType": cardNumber ? "extendCard" : "extendCards",
                    "cardNumber": cardNumber,
                    "cardNumbers": cardNumbers
                },
                data => this.setState({
                    result: data.records.result,
                    isDone: data.records.statusCode === 200,
                    isError: data.records.statusCode !== 200,
                    isLoaderVisible: false
                }),
                error => this.setState({ isLoaderVisible: false }))
        });
    }

    render() {
        return (
            <Modal {...{
                title: this.props.translation.title,
                onCloseButtonClick: this.props.onModalClose,
                content:
                    <>
                        {this.props.name && <p className="modals-extend-card-info-text">{this.props.translation.contentExtendCard(this.props.name)}</p>}
                        {this.props.numbers && <p className="modals-extend-card-info-text">{this.props.translation.contentExtendCards(this.props.numbers.length)}</p>}
                    </>,
                isSaveButton: true,
                actionButtonTitle: this.props.translation.extendButton,
                onActionButtonClick: () => this.extendCard(this.props.number, this.props.numbers),
                isLoaderVisible: this.state.isLoaderVisible,
                isDone: this.state.isDone,
                isError: this.state.isError,
                result: this.state.result,
                height: 56
            }} />
        )
    }
});

export const UnblockCard = connect(state => ({ translation: state.translation.cards.unblockCardModal }), null)(class extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { isLoaderVisible: false, isDone: false, isError: false, result: null };
    }

    unblockCard = (cardNumber, cardNumbers, blockReason) => {
        this.setState({ isLoaderVisible: true }, () => {
            this.props.updateCards(
                {
                    "requestType": cardNumber ? "unblockCard" : "unblockCards",
                    "cardNumber": cardNumber,
                    "cardNumbers": cardNumbers
                },
                data => this.setState({
                    result: data.records.result,
                    isDone: data.records.statusCode === 200,
                    isError: data.records.statusCode !== 200,
                    isLoaderVisible: false
                }),
                error => this.setState({ isLoaderVisible: false }))
        });
    }

    onFieldChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    }

    render() {
        return (
            <Modal {...{
                title: this.props.translation.title,
                onCloseButtonClick: this.props.onModalClose,
                content:
                    <>
                        {this.props.name && <p className="modals-block-card-info-text">{this.props.translation.contentUnblockCard(this.props.name)}</p>}
                        {this.props.numbers && <p className="modals-block-card-info-text">{this.props.translation.contentUnblockCards(this.props.numbers.length)}</p>}
                    </>,
                isSaveButton: true,
                actionButtonTitle: this.props.translation.blockButton,
                onActionButtonClick: () => this.unblockCard(this.props.number, this.props.numbers),
                isLoaderVisible: this.state.isLoaderVisible,
                isDone: this.state.isDone,
                isError: this.state.isError,
                result: this.state.result,
                height: 60
            }} />
        )
    }
});

const SSO_CONFIRM_PATH = '/login/confirm';

export const RevealPin = connect(
    state => ({
        login: state.login,
        translation: state.translation.cards.revealPinModal,
    }),
    dispatch => ({
        gateway: (path, jwt, body, success, error, method) => gatewayRequest(dispatch, path, jwt, body, success, error, method),
        sso: (path, formData, success, error) => ssoRequest(dispatch, path, formData, success, error),
    })
)(class extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isLoaderVisible: false, isDone: false, isError: false,
            result: null, pin: null, autoHideTimer: null,
            verificationCode: null,
        };
        this.pollInterval = null;
    }

    componentWillUnmount() {
        if (this.pollInterval) clearTimeout(this.pollInterval);
        if (this.state.autoHideTimer) clearTimeout(this.state.autoHideTimer);
    }

    getAuthMethod = () => {
        const method = this.props.authMethod;
        if (method === 'mobileid') return 'mobileid';
        return 'smartid';
    }

    onAction = () => {
        if (this.state.isLoaderVisible) return;
        if (!this.props.gatewayToken) {
            this.setState({ isError: true, result: this.props.translation.error });
            return;
        }
        this.setState({ isLoaderVisible: true, isError: false, result: null }, () => {
            this.initReveal(this.props.gatewayToken);
        });
    }

    initReveal = (jwtToken) => {
        const personalCode = this.props.login.privateClientData && this.props.login.privateClientData.personalCode;
        this.props.gateway('/pin/reveal-init', jwtToken, {
            card_number: this.props.number,
            idcode: personalCode,
            caller: 'self-service:' + personalCode,
        }, data => {
            if (!data || !data.success) {
                this.setState({ isLoaderVisible: false, isError: true, result: this.props.translation.error });
                return;
            }
            this.initSsoAuth(data.sso_data, data.token, jwtToken, personalCode);
        }, () => this.setState({ isLoaderVisible: false, isError: true, result: this.props.translation.error }));
    }

    initSsoAuth = (ssoData, revealToken, jwtToken, personalCode) => {
        const authMethod = this.getAuthMethod();

        const formData = new FormData();
        formData.append('action', 'init');
        formData.append('method', authMethod);
        formData.append('idcode', personalCode);
        formData.append('data', ssoData);
        formData.append('lang', 'et');
        if (authMethod === 'mobileid') {
            const phone = this.props.login.privateClientData && this.props.login.privateClientData.phone;
            if (phone) formData.append('phone', phone);
        }

        this.props.sso(SSO_CONFIRM_PATH, formData, data => {
            if (!data || data.status !== 1) {
                this.setState({ isLoaderVisible: false, isError: true, result: data && data.error || this.props.translation.error });
                return;
            }
            this.setState({ verificationCode: data.content });
            const pollDelay = (data.checkstatus || 2) * 1000;
            this.pollSsoStatus(ssoData, revealToken, jwtToken, pollDelay, authMethod, data.sid_session);
        }, () => this.setState({ isLoaderVisible: false, isError: true, result: this.props.translation.error }));
    }

    pollSsoStatus = (ssoData, revealToken, jwtToken, pollDelay, authMethod, sidSession) => {
        const personalCode = this.props.login.privateClientData && this.props.login.privateClientData.personalCode;
        const poll = () => {
            const formData = new FormData();
            formData.append('action', 'status');
            formData.append('method', authMethod);
            formData.append('sid_session', sidSession);
            formData.append('idcode', personalCode);
            formData.append('data', ssoData);
            formData.append('lang', 'et');

            this.props.sso(SSO_CONFIRM_PATH, formData, data => {
                if (data && data.status === 2) {
                    this.pollInterval = null;
                    this.setState({ isLoaderVisible: false, isError: true, verificationCode: null, result: data.error || this.props.translation.error });
                    return;
                }
                if (data && data.status === 1 && data.url) {
                    this.pollInterval = null;
                    this.fetchPin(revealToken, jwtToken);
                    return;
                }
                // Still pending — poll again
                this.pollInterval = setTimeout(poll, pollDelay);
            }, () => {
                // Error — retry
                this.pollInterval = setTimeout(poll, pollDelay);
            });
        };
        this.pollInterval = setTimeout(poll, pollDelay);
    }

    fetchPin = (revealToken, jwtToken) => {
        this.props.gateway(`/pin/reveal-status?token=${revealToken}`, jwtToken, null, data => {
            if (data && data.status === 'ready' && data.pin) {
                const autoHideTimer = setTimeout(() => {
                    this.setState({ pin: null, isDone: false });
                }, 30000);
                this.setState({ isLoaderVisible: false, isDone: true, pin: data.pin, verificationCode: null, autoHideTimer });
            } else {
                this.setState({ isLoaderVisible: false, isError: true, verificationCode: null, result: this.props.translation.error });
            }
        }, () => this.setState({ isLoaderVisible: false, isError: true, verificationCode: null, result: this.props.translation.error }), 'GET');
    }

    render() {
        let content;
        if (this.state.pin) {
            content = (
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <p>{this.props.translation.pinResult}</p>
                    <div style={{ fontSize: '32px', fontWeight: 'bold', letterSpacing: '8px', marginTop: '10px' }}>{this.state.pin}</div>
                </div>
            );
        } else if (this.state.verificationCode) {
            content = (
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <p>{this.props.translation.verificationCode}</p>
                    <div style={{ fontSize: '32px', fontWeight: 'bold', letterSpacing: '4px', marginTop: '10px' }}>{this.state.verificationCode}</div>
                </div>
            );
        } else {
            content = <ModalText text={this.props.translation.confirmText} />;
        }
        return (
            <Modal {...{
                title: this.props.translation.title,
                onCloseButtonClick: () => {
                    if (this.pollInterval) clearTimeout(this.pollInterval);
                    if (this.state.autoHideTimer) clearTimeout(this.state.autoHideTimer);
                    this.props.onModalClose();
                },
                content,
                isSaveButton: true,
                onActionButtonClick: this.state.pin || this.state.verificationCode ? null : () => this.onAction(),
                actionButtonTitle: this.state.pin || this.state.verificationCode ? null : this.props.translation.confirmButton,
                isLoaderVisible: this.state.isLoaderVisible,
                isDone: this.state.isDone,
                isError: this.state.isError,
                result: this.state.pin
                    ? <span>{this.props.translation.pinResult}<br/><span style={{ fontSize: '32px', fontWeight: 'bold', letterSpacing: '8px' }}>{this.state.pin}</span></span>
                    : this.state.result,
                height: this.state.pin ? 140 : (this.state.verificationCode ? 140 : 112),
            }} />
        );
    }
});

export const ChangeCrmPin = connect(
    state => ({
        login: state.login,
        translation: state.translation.cards.changeCrmPinModal,
    }),
    dispatch => ({ cardsRequest: (body, success, error) => businessCardsRequest(dispatch, body, success, error) })
)(class extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            oldPin: '', pin1: '', pin2: '',
            isLoaderVisible: false, isDone: false, isError: false, result: null
        };
    }

    onAction = () => {
        if (this.state.isLoaderVisible) return;
        if (this.state.oldPin.length < 4) {
            this.setState({ result: this.props.translation.pinTooShort, isError: true });
            return;
        }
        if (this.state.pin1 !== this.state.pin2) {
            this.setState({ result: this.props.translation.pinNotEqual, isError: true });
            return;
        }
        if (this.state.pin1.length < 4) {
            this.setState({ result: this.props.translation.pinTooShort, isError: true });
            return;
        }
        this.setState({ isLoaderVisible: true }, () => {
            this.props.cardsRequest(
                {
                    requestType: 'changeCrmPin',
                    accNr: this.props.login.currentRole.accnr,
                    token: this.props.login.token,
                    cardNumber: this.props.number,
                    oldPin: this.state.oldPin,
                    newPin1: this.state.pin1,
                    newPin2: this.state.pin2,
                },
                data => {
                    const status = data.records.statusCode;
                    let result = data.records.result;
                    if (!result && status === 401) result = this.props.translation.wrongOldPin;
                    if (!result && status === 403) result = this.props.translation.cardBlocked;
                    if (!result && status !== 200) result = this.props.translation.error;
                    this.setState({
                        result: result || this.props.translation.success,
                        isDone: status === 200,
                        isError: status !== 200,
                        isLoaderVisible: false
                    });
                },
                error => this.setState({ isLoaderVisible: false })
            );
        });
    }

    onPinChange = (type, e) => {
        const val = e.target.value;
        if (isNaN(val) || val.length > 4) return;
        this.setState({ [type]: val });
    }

    render() {
        return (
            <Modal {...{
                title: this.props.translation.title,
                onCloseButtonClick: this.props.onModalClose,
                content: [
                    <ModalInputText {...{
                        inputType: 'password',
                        key: 'oldPin',
                        text: this.props.translation.enterOldPin,
                        id: "oldPin",
                        value: this.state.oldPin,
                        required: true,
                        maxLength: 4,
                        onChange: (e) => this.onPinChange('oldPin', e)
                    }} />,
                    <ModalInputText {...{
                        inputType: 'password',
                        key: 'pin1',
                        text: this.props.translation.enterNewPin,
                        id: "pin1",
                        value: this.state.pin1,
                        required: true,
                        maxLength: 4,
                        onChange: (e) => this.onPinChange('pin1', e)
                    }} />,
                    <ModalInputText {...{
                        inputType: 'password',
                        key: 'pin2',
                        text: this.props.translation.enterNewPinAgain,
                        id: "pin2",
                        value: this.state.pin2,
                        required: true,
                        maxLength: 4,
                        onChange: (e) => this.onPinChange('pin2', e)
                    }} />
                ],
                isSaveButton: true,
                onActionButtonClick: () => this.onAction(),
                actionButtonTitle: this.props.translation.confirmButton,
                isLoaderVisible: this.state.isLoaderVisible,
                isDone: this.state.isDone,
                isError: this.state.isError,
                result: this.state.result,
                height: 262
            }} />
        );
    }
});

export const ActivateCard = connect(state => ({
    translation: state.translation.cards.activateCardModal,
}), null)(class extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isLoaderVisible: false,
            isDone: false,
            isError: false,
            result: null,
        };
    }

    activateCard = (cardNumber, cardNumbers) => {
        this.setState({ isLoaderVisible: true }, () => {
            this.props.updateCards({
                requestType: cardNumber ? 'activateCard' : 'activateCards',
                cardNumbers,
                cardNumber,
            }, (data) => {
                this.setState({
                    result: data.records.result,
                    isDone: data.records.statusCode === 200,
                    isError: data.records.statusCode !== 200,
                    isLoaderVisible: false,
                });
            }, (error) => {
                this.setState({ isLoaderVisible: false });
            });
        });
    }

    onFieldChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    }

    render() {
        return (
            <Modal {...{
                title: this.props.translation.title,
                onCloseButtonClick: this.props.onModalClose,
                content: <div />,
                isSaveButton: true,
                actionButtonTitle: this.props.translation.activateButton,
                onActionButtonClick: () => this.activateCard(this.props.number, this.props.numbers),
                isLoaderVisible: this.state.isLoaderVisible,
                isDone: this.state.isDone,
                isError: this.state.isError,
                result: this.state.result,
            }} />
        )
    }
});
